
<button
id="uploadFileModalBtn"
data-toggle="modal"
data-target="#uploadFileModal"
[hidden]="true">
Upload File Modal
</button>
<!--START MODAL ADD-->
<div
  id="uploadFileModal"
  class="modal fade ofm-modal"
  [class.ofm-modal--edit]="otaeditfile"
  data-keyboard="false"
  data-backdrop="static">
<div class="modal-dialog modal-lg" [class.modal-dialog-centered]="otaeditfile" role="document">
  <div class="modal-content bd-0 bg-transparent overflow-hidden ofm-modal__content">
    <div class="modal-body p-0">
      <div class="row no-gutters">
        <div class="col-12">
          @if (!otaeditfile) {
<span #closeModal class="pull-right closeBtn" (click)="closeOTAFileUploadModal()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </span>
}
          @if (otaeditfile) {
<span #closeModal class="pull-right closeBtn" data-dismiss="modal" (click)="cancelModal()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </span>
}
          <div class="modal-box p-3 mt-4">
            <div class="reply-header">
              <h5>
                @if (otaeditfile) {
                  <span class="ofm-modal__ico" aria-hidden="true">
                    <i class="fa fa-pencil"></i>
                  </span>
                }
                @if (EOTA_Authorities && EOTA_Authorities.authorities && EOTA_Authorities.authorities.includes('WRITE') && fileUploadType!=null) {
<span
                 
                  class="toggle-type"
                  ngbTooltip="Select Type" placement="left"
                  (click)="onTypeSelect(null)">
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </span>
}
                @if (fileUploadType==null) {
<span>New File Upload</span>
}
                @if (fileUploadType=='device' && !otaeditfile) {
<span>Device File Upload</span>
}
                @if (fileUploadType=='device' && otaeditfile) {
<span>Device File Edit</span>
}
                @if (fileUploadType=='ecu') {
<span>ECU OTA File Upload</span>
}
              </h5>
            </div>
            <!-- Type Selection Start -->
            @if (fileUploadType==null) {
<div class="row type-selection-row mt-0">
              <div class="col-12 wrapper-bridge">
                <div class="grid-container">
                  <!-- Device Ota Type Card -->
                  <div class="card-outer animated fadeIn">
                    <div class="custom-card" (click)="onTypeSelect('device')">
                      <div class="custom-card-content type-card">
                        <h6 class="title">Device OTA File</h6>
                        <label>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam delectus cupiditate facilis sapiente beatae saepe, velit eligendi culpa, error unde incidunt assumenda quaerat recusandae iure voluptate enim similique tempora voluptas!</label>
                        <i class="fa fa-microchip" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                  <!-- ECU Ota Type Card -->
                  @if (EOTA_Authorities && EOTA_Authorities.authorities && EOTA_Authorities.authorities.includes('WRITE')) {
<div class="card-outer animated fadeIn">
                    <div class="custom-card" (click)="onTypeSelect('ecu')">
                      <div class="custom-card-content type-card">
                        <h6 class="title">ECU OTA File</h6>
                        <label>Lorem ipsum dolor sit amet consectetur adipisicing elit. Officia deleniti debitis sint, pariatur natus alias autem cupiditate odio voluptatibus beatae illum magnam aperiam dolor voluptates, ad distinctio quasi eius omnis!</label>
                        <i class="fa fa-hdd-o" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
}
                </div>
              </div>
            </div>
}
            <!-- Type Selection End -->
            <!-- Form Start -->
            @if (fileUploadType!=null) {
<div class="login-content">
              <!-- Device File Form Start -->
              @if (fileUploadType==='device') {
<form
               
                action="javascript:void(0);"
                novalidate
                #f="ngForm"
                method="POST"
                class="margin-bottom-0">
                <div class="row align-items-center my-2">
                  <div class="col-sm-8"></div>
                  @if (dataSource.length < 5) {
<div class="col-md-4 text-right">
                    @if (!otaeditfile) {
<button
                      class="btn small-screen-btn mx-0 btn-outline-primary btn-sm"
                      type="button"
                      (click)="addRow()">
                      <i class="fa fa-plus-circle"></i> Add More Files
                    </button>
}
                  </div>
}
                </div>
                <div class="scrollable-modal-body add-file-modal">
                  <!-- Dynamic Row Starts-->
                  @for (divData of dataSource; track divData; let i = $index) {
                  <div>
                    <div class="row mb-2 align-items-center">
                      <!-- Folder Selection -->
                      <!-- <div class="col-md-6 form-input sm-form-design mb-2">
                        <ng-select class="custom with-label" id="folder{{i}}" name="folder{{i}}" #folder="ngModel" bindLabel="name"
                          placeholder="Select or Add a Folder" addTagText="Add New Folder" [items]="folders"
                          [addTag]="true" [hideSelected]="true" [(ngModel)]="columns[i]['folder']"
                          [disabled]="otaeditfile"
                          (change)="onFolderChange($event, i)">
                        </ng-select>
                        <label class="control-label">Folder</label>
                      </div> -->
                      <!-- File Type Selection -->
                      @if (!otaeditfile) {
                        <div class="col-md-6 form-input sm-form-design mb-2">
                          <ng-select
                            class="custom with-label"
                            required
                            name="otaType{{i}}"
                            id="otaType{{i}}"
                            #otaType="ngModel"
                            bindLabel="displayName"
                            bindValue="key"
                            placeholder="Select OTA"
                            [items]="deviceFileTypes"
                            [(ngModel)]="columns[i]['otaType']"
                            (change)="changeExtension(i)">
                          </ng-select>
                          <label class="control-label">File Type <span class="text-danger">*</span></label>
                          <div [hidden]="otaType.valid || (otaType.pristine && !f.submitted)">
                            <small class="text-danger">Please select file type</small>
                          </div>
                        </div>
                      }
                       <!-- select file -->
                       @if (!otaeditfile) {
                        <div class="col-md-6 form-input sm-form-design mb-2">
                          <span class="text-danger" style="position: absolute; left: 103px; top: -6px;">*</span>
                          <input
                            required
                            #inputFile
                            name="file"
                            type="file"
                            class="form-control-file"
                            id="exampleFormControlFile1"
                            autocomplete="off"
                            [accept]="columns[i].fileExtension"
                            (change)="getUploadedFile(inputFile, i)"
                          />
                          @if (attachedFile && !columns[i]['fileName']) {
                            <div>
                              <small class="text-danger">Please attach file</small>
                            </div>
                          }
                          <a ngbTooltip="Remove File" placement="top" [ngClass]="{'d-inline-block':i != 0}"
                              class="d-none deleteRow-btn text-left cursor-pointer" (click)="deleteRow(i)">
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                        }
                      <!-- File name -->
                      <div class="col-md-6 form-input sm-form-design mb-2">
                        <input
                          #fileName{{i}}
                          type="text"
                          class="form-control h5-email"
                          name="newFolderName{{i}}"
                          id="newFolderName{{i}}"
                          autocomplete="off"
                          tabindex="2"
                          [placeholder]="otaeditfile ? 'Package Name' : 'Please enter File Name'"
                          #newFolderName="ngModel"
                          [value]=""
						              [disabled]="otaeditfile"
                          [(ngModel)]="columns[i]['newFolderName']"
                          (keydown)="$event.keyCode != 32 ? $event:$event.preventDefault()"
                          required>
                        <label class="control-label">
                          {{ otaeditfile ? 'Package Name' : 'File Name' }}
                          <span class="text-danger">*</span>
                        </label>
                        <div [hidden]="newFolderName.valid || (newFolderName.pristine && !f.submitted) || otaeditfile">
                          <small class="text-danger">Please enter File Name</small>
                        </div>
                      </div>
                      <!-- Expected file version -->
                      <div class="col-md-6 form-input sm-form-design mb-2">
                        <input
                          type="text"
                          class="form-control h5-email"
                          name="fileVersion{{i}}"
                          id="fileVersion{{i}}"
                          autocomplete="off"
                          tabindex="2"
                          placeholder="Please enter File Name"
                          #fileVersion="ngModel"
                          [value]=""
						              [disabled]="otaeditfile"
                          [(ngModel)]="columns[i]['fileVersion']"
                          (keydown)="$event.keyCode != 32 ? $event:$event.preventDefault()">
                        <label class="control-label">Expected File Version</label>
                      </div>
                      <div
                        class="form-input sm-form-design ofm-desc-field"
                        [ngClass]="otaeditfile ? 'col-md-12 mt-1' : 'col-md-6'">
                        <textarea 
                          type="text"
                          class="form-control h5-email"
                          name="DescrName{{i}}"
                          id="DescrName{{i}}"
                          autocomplete="off"
                          placeholder="Please enter Description Name"
                          #DescrName="ngModel"
                          [value]=""
                          rows="4" 
                          cols="50"
                          [maxlength]="descMax"
                          (keyup)="onKeyPress($event)"
                          [(ngModel)]="columns[i]['DescrName']"></textarea>
                        <label class="control-label">Description</label>
                        <span class="ofm-desc-counter">{{ (columns[i]['DescrName'] || '').length }}/{{ descMax }}</span>
                      </div>
                    </div>
                    <hr>
                  </div>
                }
                  <!-- Dynamic Row Ends -->
                </div>
                <div class="row pt-3">
                  <div class="col-lg-6 alertBack darbyColor alertBack d-none d-sm-block emptyDiv">&nbsp;</div>
                  <div class="col-lg-6 login-buttons text-right">
                    @if (!otaeditfile) {
<button class="btn btn-outline-secondary small-screen-btn mr-2" 
                    (click)="closeModal(f)">Cancel
                    </button>
}
                    @if (otaeditfile) {
<button
                      class="btn btn-outline-secondary alertBtn small-screen-btn mr-2"
                      (click)="cancelModal()"  type="cancel">
                      Cancel
                    </button>
}
                    <button type="button" id="close-modal" data-dismiss="modal" 
                          style="display: none">Close
                    </button>
                    @if (!otaeditfile) {
<button
                    class="btn small-screen-btn btn-success" 
                    [disabled]="disable" (click)="uploadMultiFiles(f.valid, f)" type="submit">
                    Upload
                    </button>
}
                    @if (otaeditfile) {
<button
                    class="btn small-screen-btn btn-success"
                    [disabled]="disable"
                    (click)="uploadMultiFiles(f.valid, f)"
                    type="submit">
                    Save
                    </button>
}
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-12">
                    @if (incrimentBy) {
<div class="progress">
                      <div
                        class="progress-bar"
                        [ngbTooltip]="uploadProgress + '% uploaded successfully' "
                        placement="top"
                        [style.width]="uploadProgress + '%'"
                        role="progressbar"
                        aria-valuenow="0"
                        aria-valuemin="0"
                        aria-valuemax="100">
                      </div>
                    </div>
}
                  </div>
                </div>
              </form>
}
              <!-- Device File Form End -->
              <!-- ECU OTA Form Start -->
              @if (fileUploadType==='ecu') {
<form
               
                action="javascript:void(0);"
                novalidate
                #ecuForm="ngForm"
                (ngSubmit)="uploadMultiFiles(ecuForm.valid, ecuForm)"
                method="POST"
                class="margin-bottom-0">
                <div class="row align-items-center my-2">
                  <div class="col-sm-8"></div>
                  @if (dataSource.length < 5) {
<div class="col-md-4 text-right">
                    <button
                      class="btn small-screen-btn mx-0 btn-outline-primary btn-sm"
                      type="button"
                      (click)="addRow()">
                      <i class="fa fa-plus-circle"></i> Add More Files
                    </button>
                  </div>
}
                </div>
                <div class="scrollable-modal-body add-file-modal">
                  <!-- Dynamic Row Starts-->
                  @for (divData of dataSource; track divData; let i = $index) {
<div>
                    <div class="row mb-2 align-items-center">
                      <!-- File Type Selection -->
                      <div class="col-md-4 form-input sm-form-design">
                        <select
                          required
                          class="form-control"
                          name="otaType{{i}}"
                          id="otaType{{i}}"
                          #otaType="ngModel"
                          data-parsley-required="true"
                          [(ngModel)]="columns[i]['otaType']"
                          (change)="changeExtension(i)">
                          <option [value]="undefined" selected disabled>Select OTA</option>
                          @for (ota of ecuFileTypes; track ota) {
<option [value]="ota.key">{{ota.displayName}}</option>
}
                        </select>
                        <label class="control-label">File Type <span class="text-danger">*</span></label>
                        <div [hidden]="otaType.valid || (otaType.pristine && !ecuForm.submitted)">
                          <small class="text-danger">Please select file type</small>
                        </div>
                      </div>
                      <!-- Ecu Group Selection if EOTA Enabled -->
                      <div class="col-md-4 form-input sm-form-design">
                        <select
                          required
                          class="form-control"
                          name="ecuGroup{{i}}"
                          id="ecuGroup{{i}}"
                          placeholder="Select ECU Group"
                          [(ngModel)]="columns[i]['selectedEcuGroup']"
                          (change)="getEcuNames(i)"
                          #ecuGroup="ngModel">
                          <option [value]="undefined" selected disabled>Select ECU Group</option>
                          @for (ecuGroup of columns[i]['ecuGroupList']; track ecuGroup) {
<option [value]="ecuGroup">{{ecuGroup}}</option>
}
                        </select>
                        <label class="control-label">ECU Group <span class="text-danger">*</span></label>
                        <div [hidden]="ecuGroup.valid || (ecuGroup.pristine && !ecuForm.submitted)">
                          <small class="text-danger">Please select Ecu Group.</small>
                        </div>
                      </div>
                      <!-- Ecu Name Selection if EOTA Enabled -->
                      <div class="col-md-4 form-input sm-form-design">
                        <select
                          required
                          class="form-control"
                          name="ecuName{{i}}"
                          id="ecuName{{i}}"
                          placeholder="Select ECU Name"
                          [(ngModel)]="columns[i]['selectedEcuName']"
                          #ecuName="ngModel">
                          <option [value]="undefined" selected disabled>Select ECU Name</option>
                          @for (ecuName of columns[i]['ecuNameList']; track ecuName) {
<option [value]="ecuName">{{ecuName}}</option>
}
                        </select>
                        <label class="control-label">ECU Name <span class="text-danger">*</span></label>
                        <div [hidden]="ecuName.valid || (ecuName.pristine && !ecuForm.submitted)">
                          <small class="text-danger">Please select Ecu Name.</small>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2 align-items-center">
                      <div class="col-md-6 form-input sm-form-design">
                        <input
                          #eotaFileName{{i}}
                          type="text"
                          class="form-control h5-email"
                          name="newFolderName{{i}}"
                          id="newFolderName{{i}}"
                          autocomplete="off"
                          tabindex="2"
                          placeholder="Please enter File Name"
                          #newFolderName="ngModel"
                          [value]=""
                          [(ngModel)]="columns[i]['newFolderName']"
                          (keydown)="$event.keyCode != 32 ? $event:$event.preventDefault()"
                          required>
                        <label class="control-label">File Name <span class="text-danger">*</span></label>
                        <div [hidden]="newFolderName.valid || (newFolderName.pristine && !ecuForm.submitted)">
                          <small class="text-danger">Please enter File Name</small>
                        </div>
                      </div>
                      <div class="col-md-6 form-input sm-form-design">
                        <span class="text-danger" style="position: absolute; left: 103px; top: -6px;">*</span>
                        <input
                          required
                          #inputFile
                          name="file"
                          type="file"
                          class="form-control-file"
                          id="exampleFormControlFile1"
                          autocomplete="off"
                          [accept]="columns[i].fileExtension"
                          (change)="getUploadedFile(inputFile, i)"
                        />
                        @if (attachedFile && !columns[i]['fileName']) {
<div>
                          <small class="text-danger">Please attach file</small>
                        </div>
}
                        <a ngbTooltip="Remove File" placement="top" [ngClass]="{'d-inline-block':i != 0}"
                           class="d-none deleteRow-btn text-left cursor-pointer" (click)="deleteRow(i)">
                          <i class="fa fa-trash"></i>
                        </a>
                      </div>
                    </div>
                    <hr>
                  </div>
}
                  <!-- Dynamic Row Ends -->
                </div>
                <div class="row pt-3">
                  <div class="col-lg-6 alertBack darbyColor alertBack d-none d-sm-block emptyDiv">&nbsp;</div>
                  <div class="col-lg-6 login-buttons text-right">
                    <button class="btn btn-outline-secondary small-screen-btn mr-2" data-dismiss="modal">Cancel
                    </button>
                    <button
                      class="btn small-screen-btn btn-success"
                      [disabled]="disable"
                      type="submit">
                      Upload
                    </button>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-12">
                    @if (incrimentBy) {
<div class="progress">
                      <div
                        class="progress-bar"
                        [ngbTooltip]="uploadProgress + '% uploaded successfully' "
                        placement="top"
                        [style.width]="uploadProgress + '%'"
                        role="progressbar"
                        aria-valuenow="0"
                        aria-valuemin="0"
                        aria-valuemax="100">
                      </div>
                    </div>
}
                  </div>
                </div>
              </form>
}
              <!-- ECU OTA Form End -->
            </div>
}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<!--END MODAL ADD -->